import { useLocation } from "react-router";
import { BlockTitle } from "@blocks/Blocks";
import LoadMore from "@components/LoadMore/LoadMore";
import EventsAwardsNewsListingStories from "@events-awards/EventsAwardsNewsListingStories";
import { getMoreNewsStoriesCardProps } from "@events-awards/utils/helpers";
import { EventsAwardsNewsContextData } from "@events-awards/utils/types";
import { useListingLoadMoreStories } from "@particles/listing/hooks/useListingLoadMoreStories";
import { compact } from "lodash-es";

/**
 * Component to render news section on News page for event and awards
 */
const EventsAwardsNews = ({
  articles,
}: EventsAwardsNewsContextData): React.ReactElement => {
  const matchedCategory = useLocation().pathname.replace("/", "");
  const [parentCategory = "", childCategory = ""] = matchedCategory.split("/");
  const uniqueCategoryQuery = compact([
    parentCategory !== "keywords" && parentCategory,
    childCategory,
  ]).join("_");

  const { handleLoadMore, loadMoreData, hasMoreStories } =
    useListingLoadMoreStories({
      templateProps: getMoreNewsStoriesCardProps,
      initialList: articles,
      pageType: "section",
      size: 10,
      sections: [uniqueCategoryQuery],
    });

  const handleClickLoadMore = async () => {
    await handleLoadMore(articles);
  };

  return (
    <section data-testid="events-awards-news-component">
      <BlockTitle
        text="News"
        rootClassName="font-poppins text-4xl font-medium text-gray-850 md:text-6xl lg:text-8xl mb-2"
      />

      <div className="stories">
        {[...articles, ...loadMoreData].map((articleProps, index) => {
          return (
            <EventsAwardsNewsListingStories
              key={index}
              articleProps={articleProps}
            />
          );
        })}
      </div>

      {hasMoreStories ? (
        <LoadMore
          rootClassName="my-4"
          onLoadMore={handleClickLoadMore}
          hasMore={hasMoreStories}
          loadText="load more"
        />
      ) : null}
    </section>
  );
};

export default EventsAwardsNews;
